// extracted by mini-css-extract-plugin
export default {"contactInfo":"ContactPage_contactInfo__S2g9P"};